module.exports = __webpack_public_path__ + "static/media/pbs_store.b5fb84c5.png";